module.exports = __webpack_public_path__ + "static/img/CEo3.2ef73bd5.png";